module.exports = __webpack_public_path__ + "img/doorway.8b3f34c7.svg";